import { render } from "./AccountContainer.vue?vue&type=template&id=5839c732"
import script from "./AccountContainer.vue?vue&type=script&lang=js"
export * from "./AccountContainer.vue?vue&type=script&lang=js"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__